module.exports = __webpack_public_path__ + "img/Vela.ee111cda.png";